import Configuration from '../configuration';
import { $httpProvider } from '../providers';

function load() {
  return $httpProvider()({
    method: 'GET',
    url: Configuration.getTypePerturbation,
    params: {
      filter: '[{"property":"visibleSitePublic","value":true}]'
    }
  }).then(r => r.data);
}

export default {
  load
};



// WEBPACK FOOTER //
// ./src/repositories/type-perturbation.repository.js